// extracted by mini-css-extract-plugin
module.exports = {"currentPlan":"_1xoJcD"};